/**
 * @module Theme
 */

import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ChartType } from '@models/chart.model';
import { ThemeOptionType } from '@models/themeStudio.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-theme-option-axes-grid-lines-color-detail',
  templateUrl: './theme-option-axes-grid-lines-color-detail.component.html',
  styleUrls: ['./theme-option-axes-grid-lines-color-detail.component.css']
})
export class ThemeOptionAxesGridLinesColorDetailComponent implements OnInit, OnDestroy {

  @Input() themeOptions: ThemeOptionsClass;
  @Input() type: ChartType;
  @Input() axesIndex: number;
  @Input() axesXY: 'x' | 'y';

  color = ItemColor('themes');
  opacity: number;
  gridLinesColor: string;
  changedOptions$sub: Subscription;
  optionType: ThemeOptionType = 'axes_gridLines_color';

  constructor() {}

  ngOnInit() {
    this.setAttributes();

    this.changedOptions$sub = this.themeOptions.changedOptions$.subscribe({
      next:(option: ThemeOptionType) => {
        if(option === this.optionType) {
          this.setAttributes();
        }
      }
    });
  }

  ngOnDestroy() {
    this.changedOptions$sub.unsubscribe();
  }

  setAttributes() {
    this.gridLinesColor = this.themeOptions.axes(this.axesXY, this.axesIndex, this.type).gridLines.color.toString().slice(0, 7);
    this.opacity = Math.round(parseInt(this.themeOptions.axes(this.axesXY, this.axesIndex, this.type).gridLines.color.toString().slice(7, 9), 16) * 100 / 255);
  }
  
  receiveValue(value: string) {
    this.gridLinesColor = value;
    this.themeOptions.setAxes(this.optionType, value + Math.round(this.opacity * 255 / 100).toString(16), this.axesXY, this.axesIndex, [this.type]);
  }

  receiveOpacity(value: number) {
    this.opacity = value;
    if(this.opacity > 0) this.themeOptions.setAxes(this.optionType, this.gridLinesColor + Math.round(value * 255 / 100).toString(16), this.axesXY, this.axesIndex, [this.type]);
    else this.themeOptions.setAxes(this.optionType, this.gridLinesColor + '00', this.axesXY, this.axesIndex, [this.type]);
  }

}
